import React from 'react';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import TableSortLabel from '@mui/material/TableSortLabel';
import { SortDirection } from './Meta';
import { Checkbox, Theme, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
export interface ListHeadProps {
  sortDirection: SortDirection;
  sortField: string;
  onRequestSort: Function;
  rows: { id: string; label: string; fixed?: boolean }[];
  selected?: number;
  onSelectAllClick?: any;
  total?: number;
  classes?: any;
  showSelectAll?: boolean;
}

class ListHead extends React.Component<ListHeadProps> {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      sortDirection,
      sortField,
      rows,
      selected,
      onSelectAllClick,
      total,
      classes,
      showSelectAll,
    } = this.props;
    const order = sortDirection === SortDirection.ASC ? 'asc' : 'desc';
    return (
      <TableHead>
        <TableRow>
          {showSelectAll && (
            <TableCell
              align="left"
              padding="normal"
              style={{ borderBottom: '1px solid #65788B' }}
            >
              <Checkbox
                color="primary"
                classes={{
                  root: classes.checkbox,
                  indeterminate: classes.indeterminate,
                }}
                indeterminate={selected > 0 && selected < total}
                checked={selected === total}
                onChange={onSelectAllClick}
              />
            </TableCell>
          )}
          {rows.map(row => {
            return (
              <TableCell
                align="left"
                padding="normal"
                style={{ borderBottom: '1px solid #65788B' }}
                key={row.id}
                sortDirection={
                  !row.fixed && sortField === row.id ? order : false
                }
              >
                <Tooltip title="Sort" enterDelay={300}>
                  <React.Fragment>
                    {!row.fixed && (
                      <TableSortLabel
                        active={sortField === row.id}
                        direction={order}
                        onClick={this.createSortHandler(row.id)}
                        classes={{ root: classes.columnHeaderText }}
                      >
                        {row.label}
                      </TableSortLabel>
                    )}
                    {!!row.fixed && (
                      <Typography
                        variant="caption"
                        style={{
                          fontWeight: 'bold',
                          color: '#fff',
                          fontSize: '14px',
                        }}
                      >
                        {row.label}
                      </Typography>
                    )}
                  </React.Fragment>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

const tableheadStyle = (theme: Theme) => ({
  root: {},

  checkbox: {
    color: theme.palette.common.white,
  },
  indeterminate: {
    color: theme.palette.primary.main,
  },
  columnHeaderText: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: theme.palette.customComponent.textColor,
    '&:hover': {
      color: theme.palette.customComponent.listHeaderHoverColor,
    },
    '&.Mui-active': {
      color: theme.palette.customComponent.textColor,
    },
    '& .MuiTableSortLabel-icon': {
      color: 'inherit !important',
    },
  },
});
//export default EnhancedTableHead as any

export default withStyles(tableheadStyle)(ListHead as any);
